import React from "react";
import { Button as AriaButton } from "react-aria-components";
import { Avatar, Button, Text } from "ui-components";

import { UserResponseEntity } from "@/src/hooks/api/generated";

export interface IInvitationListCardProps {
  user: UserResponseEntity;
  onRejectInvitation?: () => void;
  onAcceptInvitation?: () => void;
}
export function InvitationListCard({
  user,
  onRejectInvitation,
  onAcceptInvitation,
}: IInvitationListCardProps): JSX.Element {
  return (
    <div className="flex flex-row bg-brand-gray-33 rounded-xl py-2 px-4 gap-4 md:gap-2 flex-wrap ">
      <Avatar
        src={user?.userTaxonomy?.image?.public_id}
        alt={`${user?.first_name} profile image`}
        size="md"
      />
      <div className="flex flex-col justify-center items-start ">
        <Text variant="base-bold">
          {user?.first_name}&nbsp;{user.last_name}
        </Text>
        <Text align="center">{user?.pronoun}</Text>
        <Text align="center">
          {user?.userTaxonomy?.job_title}
          {user?.userTaxonomy?.organization_name
            ? ` at ${user.userTaxonomy.organization_name}`
            : ""}
        </Text>
        <Text align="center">{user?.location?.location}</Text>
      </div>
      <div className="flex flex-1 justify-end items-center gap-2">
        <AriaButton
          onPress={onRejectInvitation}
          className="underline underline-offset-2 mr-5 outline-0"
        >
          Ignore
        </AriaButton>
        <Button size="xs" onPress={onAcceptInvitation}>
          <Text>Accept</Text>
        </Button>
      </div>
    </div>
  );
}
